import React from 'react';
import SpinLoader from '../shared/SpinLoader';
import { useTranslation } from 'react-i18next';

const SuggestionDropdown = ({
    userInput,
    suggestions,
    showSuggestions,
    activeIndex,
    setActiveIndex,
    onMouseDown,
    isCreationPermitted,
    disableScroll,
    maxSuggestionsToShow,
}) => {
    const { t } = useTranslation('shared');
    if (suggestions === null) {
        return (
            <div className={'suggestions-dropdown' + (showSuggestions ? ' show' : ' hide')}>
                <div className='dd-item text-center'>
                    <br />
                    <SpinLoader isLoading />
                </div>
            </div>
        );
    }
    const scrollStyle = disableScroll ? null : { maxHeight: '200px', overflowY: 'scroll' };
    
    let suggestionList;
    const filteredSuggestions = maxSuggestionsToShow ? suggestions.slice(0, maxSuggestionsToShow) : suggestions;

    if (showSuggestions && filteredSuggestions && filteredSuggestions.length) {
        suggestionList = filteredSuggestions.map((item, index) => {
            let className = `dd-item ${index === activeIndex ? ' dd-item-active' : null}`;
            return (
                <div
                    id={`suggestion-${index}`}
                    key={item.id ? item.id : index}
                    onMouseDown={onMouseDown}
                    onMouseOver={() => setActiveIndex(index)}
                    className={className}
                    dangerouslySetInnerHTML={{ __html: item.underlinedDetailedName ?? item.detailedName ?? t(item.name) ?? item.title }}
                />
            );
        });
    } else if (!isCreationPermitted && showSuggestions) {
        suggestionList = <div className='dd-item text-center'>Inga träffar...</div>;
    } else {
        suggestionList = null;
    }

    return (
        <div className={'suggestions-dropdown' + (showSuggestions ? ' show' : ' hide')} style={scrollStyle}>
            {suggestionList}
            {isCreationPermitted && userInput.length && (
                <div
                    id={`suggestion-${filteredSuggestions.length}`}
                    onMouseOver={() => setActiveIndex(filteredSuggestions.length)}
                    onMouseDown={onMouseDown}
                    className={`dd-item create-item ${activeIndex === filteredSuggestions.length ? ' dd-item-active' : ''}`}>
                    <div className='oi oi-sm oi-plus create-icon' />
                    Skapa "{userInput}"
                </div>
            )}
        </div>
    );
};

export default SuggestionDropdown;
